import ConvertJsonToCsv from "app/services/jsonToCsv/jsonToCsv.service";
import { LocaleService } from 'app/services/locale/locale.service';
import { CustomerGeneratorService } from "external-services/customer-generator-service";
import BookingService from "app/services/booking/booking.service";
import AdminService from 'external-services/diary-admin-service/admin.service';
import DateUtilsService from 'external-services/date-utils-service';

const NS = 'BookingSizeCtrl';

export default function BookingSizeCtrl(
  $rootScope, $scope, $filter, $timeout
) {
  "ngInject";

  const vm = this;
  //-- define public properties
  vm.loading = false;
  vm.filterBookings = [];
  const timeZoneId = AdminService.getVenueTimezoneId();
  vm.startDate = DateUtilsService.getClearDate(null, timeZoneId);
  vm.endDate = DateUtilsService.getClearDate(null, timeZoneId);
  vm.paxMin = 8;
  vm.paxMax = null;
  vm.endDate.setDate(vm.endDate.getDate() + 30);
  vm.hideDays = true;
  // methods
  vm.loadResults = loadResults;
  vm.printReport = printReport;
  vm.exportToCsv = exportToCsv;

  loadResults();

  //-- listen
  $scope.$watch('vm.startDate', datesChanged);
  $scope.$watch('vm.endDate', datesChanged);
  $scope.$watch('vm.paxMin', loadResults);
  $scope.$watch('vm.paxMax', loadResults);

  function datesChanged() {
    if (vm.startDate && (!vm.endDate || vm.endDate.getTime() >= vm.startDate.getTime())) {
      loadResults();
    }
  }

  function loadResults() {
    vm.loadError = false;
    vm.loading = true;
    BookingService.getBetweenDates(vm.startDate, vm.endDate).then(function (bookings) {
      return filterBookings(bookings);
    }).then(function (filtedBooking) {
      vm.filterBookings = filtedBooking.sort(function (a, b) {
        return a.time - b.time;
      });
      vm.loadError = false;
      vm.loading = false;
    }).catch(function () {
      // data failed to load
      vm.loadError = true;
      vm.loading = false;
    });
  }

  function filterBookings(bookings) {
    return bookings.filter(function (booking) {
      return (booking.people >= vm.paxMin && (!vm.paxMax || booking.people <= vm.paxMax));
    });
  }

  function exportToCsv() {
    var reportName = 'BookingSize_' + LocaleService.formatDateForFilename(vm.startDate) + '_EndDate_' + LocaleService.formatDateForFilename(vm.endDate) + '_' + vm.paxMin;
    if (vm.paxMax) {
      reportName += '_' + vm.paxMax;
    }
    var bookingRows = [];
    var labels = ['Date', 'Customer', 'People'];
    // Loop over booking totals

    for (var i = 0; i < vm.filterBookings.length; i++) {
      var booking = vm.filterBookings[i];
      var rowObj = {
        // Split combined datetime: localise date portion, keep time unchanged
        date: LocaleService.formatDate(booking.time, 'medium-short') + ' ' + $filter('date')(booking.time, 'h:mma'),
        // booking and customer share same attributes used to compute the display name
        customer: CustomerGeneratorService.getDisplayName(booking),
        people: booking.people
      };
      bookingRows.push(rowObj);
    }

    ConvertJsonToCsv.downloadCsv(bookingRows, labels, reportName);
  }

  function printReport() {
    vm.printing = true;
    $timeout(function () {
      setTimeout(function () {
        window.print();
        printDone();
      }, 200);
    }, 100);
  }

  function printDone() {
    vm.printing = false;
    setTimeout(function () {
      vm.printing = false;
    }, 200);
  }
}
